module.exports = __webpack_public_path__ + "static/media/path-293-at-1x.62c5a9ba.webp";